import { useEffect, useState } from "react"
import { Bell, Search, Settings2 } from "lucide-react"
import { useWorkspaceStore } from "../stores/workspace.store"

function useClock() {
  const [time, setTime] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000)
    return () => clearInterval(id)
  }, [])
  return time
}

interface DashboardTopbarProps {
  pageName?: string
}

export function DashboardTopbar({ pageName }: DashboardTopbarProps) {
  const { currentWorkspace } = useWorkspaceStore()
  const now = useClock()

  const hh = String(now.getHours()).padStart(2, "0")
  const mm = String(now.getMinutes()).padStart(2, "0")
  const ss = String(now.getSeconds()).padStart(2, "0")

  const label = pageName || "Dashboard"
  const wsName = currentWorkspace?.name || ""

  return (
    <div className="dashboard-topbar">
      {/* Title + breadcrumb */}
      <div className="dashboard-topbar__title-wrap">
        <div className="dashboard-topbar__title">{label}</div>
        {wsName && (
          <div className="dashboard-topbar__breadcrumb">/ {wsName}</div>
        )}
      </div>

      {/* Status pill */}
      <div className="dashboard-topbar__status">
        <span className="dashboard-topbar__pulse" />
        Sistema operacional
      </div>

      {/* Search box */}
      <div className="dashboard-topbar__search">
        <Search className="w-[13px] h-[13px] flex-shrink-0" />
        <span>Buscar...</span>
        <span className="dashboard-topbar__search-kbd">⌘K</span>
      </div>

      {/* Notifications */}
      <button className="dashboard-topbar__icon-btn" title="Notificações">
        <Bell className="w-[15px] h-[15px]" />
        <span className="dashboard-topbar__notif-dot" />
      </button>

      {/* Settings */}
      <button className="dashboard-topbar__icon-btn" title="Configurações">
        <Settings2 className="w-[15px] h-[15px]" />
      </button>

      {/* Clock */}
      <span className="dashboard-topbar__clock">
        {hh}:{mm}:{ss}
      </span>
    </div>
  )
}
